import Vue from "vue"; //引入Vue
import Router from "vue-router"; //引入vue-router
Vue.use(Router); //Vue全局使用Router

const router = new Router({
  //mode: 'history',
  routes: [
    {
      path: "/index",
      name: "index",
      component: (resolve) => require(["../views/index"], resolve),
    },
    {
      path: "/",
      redirect: "/index",
    },
	{
		   // 引导页
		   path: '/guide',
		   name: 'guide',
		   component: () => import('../views/guide.vue')
	},
	{
		  path:'/fengtu',
		  name:'fengtu',
		  component: () => import('../views/fengtu.vue')
	},
	{
		  path:'/meteorology',
		  name:'meteorology',
		  component: () => import('../views/meteorology.vue')
	},
	{
		  path:'/zhongzhi',
		  name:'zhongzhi',
		  component: () => import('../views/zhongzhi.vue')
	},
	{
		  path:'/niangzao',
		  name:'niangzao',
		  component: () => import('../views/niangzao.vue')
	},
	{
		  path:'/good',
		  name:'good',
		  component: () => import('../views/good.vue')
	},
	{
		  path:'/source',
		  name:'source',
		  component: () => import('../views/source.vue')
	},
	{
		  path:'/share',
		  name:'share',
		  component: () => import('../views/share.vue')
	},
	{
		  path:'/agreement',     //用户协议
		  name:'agreement',
		  component: () => import('../views/agreement.vue')
	},
	{
		  path:'/privacy',     //隐私政策
		  name:'privacy',
		  component: () => import('../views/privacy.vue')
	},
	{
		  path:'/digitalWinery',     //数字酒庄
		  name:'digitalWinery',
		  component: () => import('../views/digitalWinery.vue')
	}
  ],
});
export default router;